export default __webpack_public_path__ + "static/media/visualizacao-relatorios.60fe0ffd.svg";